import { TokenResponse } from '@bo/ng-auth';

export class SetTokens {
  static readonly type = '[Auth] Update authentication tokens';
  constructor(public token: TokenResponse) {}
}
